import React from 'react';
import Layout from '../components/Layout';
import ResetPasswordCard from '../components/ResetPasswordCard';

function ResetPassword() {

  return (
    <Layout videoUrl="https://burakgundogan.net/videos/15869190_1080_1920_30fps.mp4">
      <ResetPasswordCard />
    </Layout>
  );
}

export default ResetPassword;